// Module
var code = "<div id=\"dialogRechazarTarea\" ng-controller=\"DialogConfirmarConComentarioCtrl\"> <p>{{ txt_titulo }}</p> <div ng-if=\"puedeAnyadirComentario\"> <input-comentario tarea-id=\"{{ tareaId }}\" mensaje=\"model.mensaje\" usuarios=\"usuariosParaCitar\"></input-comentario> <p class=\"form-description\">{{ txt_msg }}</p> </div> </div>";
// Exports
module.exports = code;